import { useNavigate } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useMode } from "../context/ModeContext";
import { MODES, MODE_META } from "../lib/modes";

// "Choose your mode" overview: one card per coding mode with a Start button (used on the Instructions page)
export const ModeOverview = ({ testId = "mode-overview" }) => {
  const { mode, setMode } = useMode();
  const navigate = useNavigate();
  const pick = (m) => { setMode(m); navigate("/"); };
  return (
    <section className="mb-8" data-testid={testId}>
      <h2 className="font-heading font-semibold text-xl sm:text-2xl mb-1">Choose your mode</h2>
      <p className="text-sm text-muted-foreground mb-4">Three ways to code, each with its own questions, points and leaderboard. Switch any time from the header.</p>
      <div className="grid gap-3 md:grid-cols-3">
        {MODES.map((m) => {
          const meta = MODE_META[m];
          const Icon = meta.icon;
          const active = mode === m;
          return (
            <div key={m} className={`rounded-2xl border-2 p-4 flex flex-col bg-background transition-colors ${active ? meta.border : "border-border"}`} data-testid={`${testId}-${m}`} data-active={active ? "true" : undefined}>
              <div className={`inline-flex items-center gap-2 font-heading font-semibold text-lg ${meta.text}`}>
                <Icon className="w-5 h-5" /> {meta.label}
                {active && <span className="ml-auto inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide rounded-full px-2 py-0.5 bg-muted text-muted-foreground" data-testid={`${testId}-${m}-current`}><Check className="w-3 h-3" /> Current</span>}
              </div>
              <p className="text-sm text-muted-foreground mt-1.5 mb-3">{meta.tagline}</p>
              <ul className="text-sm space-y-1 mb-4 flex-1">
                {meta.points.slice(0, 3).map((p) => (
                  <li key={p} className="flex items-start gap-2"><span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-current shrink-0 opacity-60" />{p}</li>
                ))}
              </ul>
              <button
                type="button"
                onClick={() => pick(m)}
                className={`inline-flex items-center justify-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${active ? "bg-muted text-foreground hover:bg-muted/70" : `${meta.pill} hover:opacity-90`}`}
                data-testid={`${testId}-${m}-start`}
              >
                {active ? "Continue" : `Start ${meta.label}`} <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};
